import { InboxModuleType } from "@/types/inboxModule.type";
import { reactive, toRefs } from "@vue/composition-api";
// @ts-ignore
import router from "@/router";
import { getUserData } from "@/auth/getUserData";
import { InboxModulePathType } from "@saysimple-platform/dtos";

// The path of the Public API requests, like https://<api>/<PublicApiEndpointPath>/a/b
export const enum PublicApiEndpointPathType {
    EMAIL = "email-chats",
    MESSAGING = "messaging-chats",
    TEAM = "team-chats",
}

const enum AclSubject {
    EMAIL = "emailInbox",
    MESSAGING = "inbox", // @NOTICE this is the "old" inbox ACL subject what now the "messaging inbox" is, but ACL hasnt changed.
}

interface RootState {
    inboxModuleType: InboxModuleType;
    publicApiEndpointPath: PublicApiEndpointPathType;
    inboxModulePath?: InboxModulePathType;
}

// Undefined by default, so you cannot have the wrong value by accident when not using the setters first.
const state: RootState = reactive({
    inboxModuleType: InboxModuleType.MESSAGING,
    publicApiEndpointPath: PublicApiEndpointPathType.MESSAGING, // Cannot be undefined when using it with Axios directly, because undefined is not allowed.
    inboxModulePath: undefined,
});

export function useInboxModuleType() {
    const setInboxModuleType = (inboxModuleType: InboxModuleType): void => {
        state.inboxModuleType = inboxModuleType;
        state.publicApiEndpointPath =
            inboxModuleType === InboxModuleType.EMAIL
                ? PublicApiEndpointPathType.EMAIL
                : PublicApiEndpointPathType.MESSAGING;
        state.inboxModulePath =
            inboxModuleType === InboxModuleType.EMAIL ? InboxModulePathType.EMAIL : InboxModulePathType.MESSAGING;
    };

    const isInboxModule = (): boolean => {
        return ["inbox", InboxModulePathType.EMAIL, InboxModulePathType.MESSAGING].includes(router.currentRoute.name);
    };

    const isInboxModuleEnabled = (inboxModuleType: InboxModuleType): boolean => {
        return getUserData().ability.some((abil) => {
            return (
                abil.subject === (inboxModuleType === InboxModuleType.EMAIL ? AclSubject.EMAIL : AclSubject.MESSAGING)
            );
        });
    };

    return {
        ...toRefs(state),
        setInboxModuleType,
        isInboxModule,
        isInboxModuleEnabled,
    };
}
